import React  from 'react';

const ArrowLeftIcon = () => {
  return <svg id="Group_357" data-name="Group 357" xmlns="http://www.w3.org/2000/svg" width="7.1" height="12.974" viewBox="0 0 7.1 12.974">
    <path id="chevron-thin-up" d="M5.488,6.429.15.883a.521.521,0,0,1,0-.732.508.508,0,0,1,.724,0L6.726,6.062a.521.521,0,0,1,0,.732L.874,12.7a.508.508,0,0,1-.724,0,.521.521,0,0,1,0-.732L5.488,6.429Z" transform="translate(0.224 0) rotate(1)" fill="#fff"/>
  </svg>;
}

export default ArrowLeftIcon;
